import { useEffect, useRef } from "react";

import arrowicon from "../../images/cashbach/Frame 18413.svg";

import "./styles.css";
import { useHistory } from "react-router-dom";
import { HomeStyled } from "./HomeStyled";

import { Carousel } from "antd";
import CurrentOffres from "../../components/CurrentOffres/CurrentOffres";
import leftarrow1 from "../../images/cashbach/arrow-left-s-line-1.svg";
import rightarrow1 from "../../images/cashbach/arrow-left-s-line-1.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllmerchantsAPI,
  getAllOffersAPI,
} from "../../redux/slices/reports/reportsService";
import { checkIsMobile } from "../../Utills/Utill";

const Home = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { allMerchantsList, allOffersList } = useSelector(
    (state: any) => state?.reports
  );

  useEffect(() => {
    dispatch(getAllmerchantsAPI({ id: "68da53018d46074c47d36613" }));
    dispatch(getAllOffersAPI({ id: "68da53018d46074c47d36613" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carouselRef = useRef<any>(null);

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  return (
    <>
      <HomeStyled>
        <div className="home-container carousel-wrapper">
          <Carousel
            dots
            ref={carouselRef}
            dotPosition="bottom"
            className="banner_img_carsousel"
          >
            {allOffersList?.data?.map((item: any, idx: number) => {
              const merchant = allMerchantsList?.data?.find(
                (m: any) => m?._id === item?.merchantId
              );

              return (
                <div className="carouse_image_wrapper" key={`car_ousel_${idx}`}>
                  <div className="text-div">
                    {merchant?.merchantImageUrl && (
                      <img
                        src={merchant?.merchantImageUrl}
                        alt={merchant?.merchantName}
                        className="merchant-logo"
                      />
                    )}

                    <h3>{item?.offerName}</h3>
                    <p>{item?.offerDiscription}</p>
                    <button
                      onClick={() =>
                        history.push("/Restuarante-details/" + item?._id)
                      }
                    >
                      Ver Oferta
                    </button>
                  </div>

                  <div className="image-div">
                    <img
                      src={item?.offerImages?.[0]}
                      alt="banner1"
                      className="h-100"
                    />
                  </div>
                  {!checkIsMobile() && (
                    <>
                      <button
                        onClick={handlePrev}
                        className="carousel-arrow left-arrow"
                      >
                        <img src={leftarrow1} alt="left arrow" />
                      </button>
                      <button
                        onClick={handleNext}
                        className="carousel-arrow right-arrow"
                      >
                        <img src={rightarrow1} alt="right arrow" />
                      </button>
                    </>
                  )}
                </div>
              );
            })}
          </Carousel>
        </div>
        <div className="instruction-section">
          <div className="instruction-text">
            <h3>Cómo ganar reembolsos con tu compra</h3>
            <p>Obtén emocionantes reembolsos en tus compras</p>
          </div>
          <div className="arrow-icon-section">
            <img src={arrowicon} alt="banner1" />
          </div>
        </div>
        <CurrentOffres
          allMerchantsList={allMerchantsList}
          allOffersList={allOffersList}
        />
      </HomeStyled>
    </>
  );
};

export default Home;
